import {
  Avatar,
  Box,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/pages/managers.module.scss";
import { useEffect } from "react";
import NOprofileImage from "../../public/assets/images/no-image.svg";
import { concatHostAndImagePath } from "../../lib/functions/utils.lib";

// export interface assignRadioProps {
//     src: string;
//     type: number;
//     title: string;
//     link: string;
//     subNumber: string;
//     assignText: string;
//     greg: boolean;
//     gregName: string;
//     gregTitle: boolean;
//     assignType: "assign" | "unassign";
// }

const AssignRadioCard = (props) => {
  const [checked, setChecked] = useState(false);
  const [checkvalue, setCheckValue] = useState("");

  useEffect(() => {
    if (checkvalue) {
      props?.getdata(checkvalue);
    }
  }, [checkvalue, checked]);

  useEffect(() => {
    if (props?.clicked) {
      setCheckValue("");
      setChecked(false);
      props.setClicked(false);
    }
  }, [props?.clicked]);

  // console.warn("check",checked,props?.clicked);

  // console.warn("checkvalue", checkvalue);
  return (
    <>
      <Paper elevation={0} className={styles.cardPaperMain}>
        <label
          className={
            props?.assignType === "assign"
              ? `${styles.selectCard} ${styles.assignBlue}`
              : props?.assignType === "unassign"
              ? `${styles.selectCard} ${styles.assignDanger}`
              : ""
          }
        >
          <input
            type="checkbox"
            checked={checked}
            name="name"
            value={props?.id}
            className={styles.customRadio}
            onChange={(e) => {
              setChecked(!checked);
              setCheckValue(e.target.value);
            }}
          />
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            className={styles.radioMedia}
          >
            <Box className={styles.leftCol}>
              {props?.avatar === "users/default.png" ? (
                <Avatar
                  alt="Remy Sharp"
                  src={NOprofileImage}
                  sx={{ width: 52, height: 52 }}
                />
              ) : (
                <Avatar
                  alt="Viral Snare"
                  src={concatHostAndImagePath(props?.avatar)}
                  sx={{ width: 52, height: 52 }}
                />
              )}
              {props?.type === 1 ? (
                <Box className={`${styles.resultStatus} ${styles.success}`}>
                  Active
                </Box>
              ) : props?.type === 0 ? (
                <Box className={`${styles.resultStatus} ${styles.inactive}`}>
                  Inactive
                </Box>
              ) : null}
            </Box>
            <Box className={styles.rightCol}>
              <List>
                <ListItem>
                  <Typography variant="h4">{props?.title}</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="h4">{props?.email}</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="caption">{props?.link}</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">
                    All Submissions: <span>{props?.subNumber}</span>
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">
                    Assigned Manager(s): <span>{props?.assignText}</span>
                  </Typography>
                  {props?.greg && (
                    <Typography variant="body1" className={styles.gregText}>
                      <span>
                        {props?.gregTitle && "Greg Pedritis"} -{" "}
                        {props?.gregName}
                      </span>
                    </Typography>
                  )}
                </ListItem>
              </List>
            </Box>
          </Stack>
        </label>
      </Paper>
    </>
  );
};

export default AssignRadioCard;
